import { IconProps } from './interfaces';

export const IconFrequency = ({ className }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.99984 2.875C6.34502 2.875 6.62484 3.15482 6.62484 3.5V10.5C6.62484 10.8452 6.34502 11.125 5.99984 11.125C5.65467 11.125 5.37484 10.8452 5.37484 10.5V3.5C5.37484 3.15482 5.65467 2.875 5.99984 2.875ZM2.58984 7.375C2.93502 7.375 3.21484 7.65482 3.21484 8L3.21484 10.5C3.21484 10.8452 2.93502 11.125 2.58984 11.125C2.24467 11.125 1.96484 10.8452 1.96484 10.5V8C1.96484 7.65482 2.24467 7.375 2.58984 7.375ZM10.0399 6C10.0399 5.65482 9.76006 5.375 9.41488 5.375C9.0697 5.375 8.78988 5.65482 8.78988 6V10.5C8.78988 10.8452 9.0697 11.125 9.41488 11.125C9.76006 11.125 10.0399 10.8452 10.0399 10.5L10.0399 6Z"
                fill="#808080"
            />
        </svg>
    );
};
